export const actionCreator = (typeReq: string, action: string) => {
  switch (typeReq) {
    case "req":
      return action + "_REQUEST";
    case "res":
      return action + "_RESPONSE";
    case "init":
      return action + "_INIT";
    case "fail":
      return action + "_FAIL";
    default:
      return action + "_FAIL";
  }
};